import { useEffect, useRef } from 'react';

function AnimateTitleThree() {
    const headingRef = useRef(null);

    useEffect(() => {
        const target = headingRef.current;
        if (!target) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    target.classList.add('animate');
                    observer.unobserve(target);
                }
            },
            { threshold: 0.5 }
        );

        observer.observe(target);

        return () => {
            observer.disconnect();
        };
    }, []);

    const words = ['Tailoring', 'Unit'];
    let globalIndex = 0;

    return (
        <h3 className="section-heading rotated" ref={headingRef}>
            <span className="qodef-e-inner">
                <span className="qodef--word">
                    {words.map((word, wordIdx) => (
                        <span className="qodef--word-wrapper" key={wordIdx} style={{ display: 'inline-flex' }}>
                            {word.split('').map((char) => {
                                const index = globalIndex++;
                                return (
                                    <span
                                        className="qode--char"
                                        key={index}
                                        style={{ '--qode-i': index }}
                                    >
                                        <span className="qode--char-inner">{char}</span>
                                    </span>
                                );
                            })}
                            {wordIdx < words.length - 1 && (
                                <span
                                    className="qode--char space"
                                    key={`space-${wordIdx}`}
                                    style={{
                                        '--qode-i': globalIndex++,
                                        display: 'inline-block',
                                        width: '0.4em', // adjust space width as needed
                                    }}
                                >
                                    <span className="qode--char-inner">&nbsp;</span>
                                </span>
                            )}
                        </span>
                    ))}
                </span>
            </span>
        </h3>
    );
}

export default AnimateTitleThree;
